import { get } from 'lodash'
import React from 'react'

import config from 'config'
import * as Page from 'containers/pages'

const publicPath = config.publicPath
const routes = [
  {
    path: `${publicPath}/assessor-assessment/activities/:activityId`,
    exact: true,
    component: props => (
      <Page.AssessorActivityAssessment
        {...props}
        params={get(props, 'match.params', {})}
      />
    )
  },
  {
    path: `${publicPath}/assessor-assessment/aj-participant-events/:ajId`,
    exact: true,
    component: props => (
      <Page.AssessorAjParticipantEventAssessment
        {...props}
        params={get(props, 'match.params', {})}
      />
    )
  },
  {
    path: `${publicPath}/assessor-assessment/residential-projects/:rpId`,
    exact: true,
    component: props => (
      <Page.AssessorResidentialProjectAssessment
        {...props}
        params={get(props, 'match.params', {})}
      />
    )
  },
  {
    path: `${publicPath}/assessor-assessment/success`,
    exact: true,
    component: props => (
      <Page.AssessorAssessmentSuccess
        {...props}
        params={get(props, 'match.params', {})}
      />
    )
  },
  {
    path: `${publicPath}/register/participant/parental-consent`,
    exact: true,
    component: props => (
      <Page.ParentalConsent
        {...props}
        params={get(props, 'match.params', {})}
      />
    )
  }
]

export default routes
